import { ConditionalLink } from '@/components/Common';
import { useAppContext } from '@/context/AppContext';
import { ArrowRight, HomeCross, HomeTick, SearchHospitalIcon } from 'ui/icons';

interface IProps {
  handleBlackListedCTAClick: () => void;
  blacklistHospitalUrl: string;
}

const LocationAccessPrompt = ({
  handleBlackListedCTAClick,
  blacklistHospitalUrl,
}: IProps) => {
  const { isWebView } = useAppContext();
  return (
    <div className="flex items-center flex-col w-full max-w-[441px] mx-auto my-auto pt-[2rem]">
      <SearchHospitalIcon />
      <h3 className="font-chromatica font-bold text-mobile-text-main leading-5 text-base mt-3">
        Search for a network hospital
      </h3>
      <div className="flex items-center mt-8">
        <div className="border border-mobile-gray-200 rounded-full p-1 mr-3">
          <HomeTick width={24} height={24} />
        </div>
        <p className="text-mobile-text-main text-sm leading-5 font-normal text-left">
          You'll only see hospitals that are part of your insurer's network for
          cashless claims
        </p>
      </div>
      <div className="flex items-center mt-5">
        <div className="border border-mobile-gray-200 rounded-full p-1 mr-3">
          <HomeCross width={24} height={24} />
        </div>
        <p className="text-mobile-text-main text-sm leading-5 font-normal text-left">
          Your insurer may not cover any claims (cashless or reimbursement) from{' '}
          <b>Blacklisted hospitals</b>
          <br />
          <ConditionalLink
            external
            href={isWebView ? null : blacklistHospitalUrl}
            onClick={handleBlackListedCTAClick}
          >
            <a className="text-sm h-fit text-mobile-hero-100 flex items-center mt-1">
              {' '}
              View list here <ArrowRight className="w-4 h-4 ml-1" />
            </a>
          </ConditionalLink>
        </p>
      </div>
    </div>
  );
};

export default LocationAccessPrompt;
